import { Button } from '@grupoboticario/flora-react';
import React, { useEffect } from 'react';
import content from 'src/common/content';
import ProductName from 'src/components/atoms/ProductName';
import ProductSku from 'src/components/atoms/ProductSku';
import ProductDescription from 'src/components/molecules/ProductDescription';
import ProductImage from 'src/components/molecules/ProductImage';
import ProductPrice from 'src/components/molecules/ProductPrice';
import ProductTags from 'src/components/molecules/ProductTags';
import Styled from './ProductDetailsStyle';

import sendGoogleAnalytics from 'src/services/googleAnalytics/sendGoogleAnalytics';
import { IProduct } from 'src/common/types/CatalogType';
import { sendProductDetailEvent } from 'src/services/googleAnalytics/enhancedEcommerce';

interface IProductDetails {
  product: IProduct;
  shouldShowResellerButton?: boolean;
  showPrice?: boolean;
}

const analyticsEvent = (label: string) => {
  sendGoogleAnalytics.event({
    eventCategory: `${process.env.BRAND_IDENTIFIER}:catalogo-virtual`,
    eventAction: 'clique',
    eventLabel: `pagina-produto:${label}`,
  });
};

const ProductDetails = ({
  product,
  shouldShowResellerButton = true,
  showPrice = true,
}: IProductDetails): JSX.Element => {
  useEffect(() => {
    sendProductDetailEvent(product);
  }, [product]);

  const isDiscountTag = (tag: string) => {
    return tag.startsWith('-');
  };

  const filterTagsToShow = (tags: string[]) => {
    if (!showPrice) {
      return tags.filter((tag) => !isDiscountTag(tag));
    }
    return tags;
  };

  return (
    <>
      <Styled.Wrapper data-testid="product-page">
        <Styled.ContentWrapper>
          <ProductImage imageUrl={product.images && product.images[0]} />
          <ProductName name={product.name} />
          <Styled.Wrapper
            css={{ display: 'flex', flexDirection: 'row', padding: '$0' }}
          >
            {showPrice && (
              <ProductPrice
                price={product.price}
                discountPrice={product.discountPrice}
              />
            )}

            <ProductTags tags={filterTagsToShow(product.tags)} />
          </Styled.Wrapper>
          <ProductSku sku={product.sku} />
          <ProductDescription description={product.description} />
        </Styled.ContentWrapper>
        {shouldShowResellerButton && (
          <Styled.Reseller>
            <Button
              as="a"
              target="_blank"
              href={`${content.products?.findReseller?.button?.url}${product.sku}`}
              aria-label={content.products?.findReseller?.button?.ariaLabel}
              data-testid="button-encontre"
              onClick={() => analyticsEvent('encontre')}
            >
              {content.products?.findReseller?.button?.label}
            </Button>
          </Styled.Reseller>
        )}
      </Styled.Wrapper>
    </>
  );
};

export default React.memo(ProductDetails);
